import { Injectable } from '@angular/core';
import { Onboarding } from '@bciti/types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export abstract class OnboardingService {
    abstract createOnboarding(onboarding: Onboarding): Observable<any>;
    abstract updateOnboarding(onboarding: Onboarding): Observable<any>;
    abstract uploadLogo(file: any): Observable<string>;
    abstract getOnboardings(): Observable<Onboarding[]>;
    abstract getOnboardingById(id: string): Observable<Onboarding>;
    abstract completeOnbarding(tag: string);
}
